import { render, staticRenderFns } from "./AdminUserInfoView.vue?vue&type=template&id=60558280&"
import script from "./AdminUserInfoView.vue?vue&type=script&lang=ts&"
export * from "./AdminUserInfoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports